import {
  INITIATE_AUTHOR_CONTENT,
  COMPLETE_AUTHOR_CONTENT,
  ERROR_AUTHOR_CONTENT,
  AEM_AUTHOR_ENDPOINT,
  AEM_AUTHOR_ENDPOINT_SSM,
  AEM_AUTHOR_ENDPOINT_FFWD,
  AEM_AUTHOR_ENDPOINT_NGM,
  AEM_AUTHOR_ENDPOINT_AMS,
  AEM_AUTHOR_ENDPOINT_AMC,
  AEM_AUTHOR_ENDPOINT_AMP,
  AEM_AUTHOR_ENDPOINT_SCT,
  AEM_VANTAGE_AUTHOR_ENDPOINT,
  AEM_HOSTED_MIGRATION_AUTHOR_ENDPOINT,
  AEM_BUSINESS_POP_MAIL_AUTHOR_ENDPOINT,
  APP_CONFIG,
  API_END_POINT_GET_PRODUCT_TYPE,
  SHOW_PRODUCT_SELECTION_OPTIONS,
  DEBUG_MODE,
  ENABLE_NEW_HEADER_FOOTER_DESIGN,
  ENABLE_LIVE_CHAT,
  LIVE_CHAT_SUPPORTED_PRODUCTS,
  API_END_POINT_UCIDN_LIST,
  SHOW_UCIDN_LIST_OPTIONS,
  PRODUCT_SELECTION_ERROR,
  AEM_ADAPTIVE_MOBILITY_EXTERNAL_AUTHOR_ENDPOINT,
} from '../app-constants';
import history from '../app-history';
import {
  getEventRouteAndUserHashDetails,
  isRedirectedAfterLogin,
  showHideOldNewHeaderFooter,
  getCurrentProduct,
  restartLiveChatForProduct,
} from '../app-actions';
import { aemApiGet, apiGetWithoutDispatch } from '../api/api-configuration';
import { getSSMCustomerData } from '../views/ssm-homepage/ssm-homepage.actions';
import { startNewBusinessCase } from '../views/business-case/business-case.actions';
import { getFFWDCustomerData } from '../views/ffwd-homepage/ffwd-homepage.actions';
import { getNGMCustomerData } from '../views/ngm-homepage/ngm-homepage.actions';
import { getAMSCustomerData } from '../views/ams-homepage/ams-homepage.actions';
import { getAMCCustomerData } from '../views/amc-homepage/amc-homepage.actions';
import { getAMPCustomerData } from '../views/amp-homepage/amp-homepage.actions';
import { getSCTCustomerData } from '../views/sct-homepage/sct-homepage.actions';

export const successActionAEMContent = (contentData) => {
  // initiate the live chat at product level
  const currentProduct = getCurrentProduct();
  window.parent.tcom.researchInsights.appConfig.currentProduct = currentProduct;
  if (ENABLE_LIVE_CHAT && contentData.liveChat) {
    // calling the function to setup salesforce content data load process
    if (window.initSFDCChat && LIVE_CHAT_SUPPORTED_PRODUCTS.includes(currentProduct)) {
      if (DEBUG_MODE) {
        console.log('live chat process started for product:', currentProduct);    // eslint-disable-line
      }
      window.liveChatContentData = contentData.liveChat;
    }
  }
  return { type: COMPLETE_AUTHOR_CONTENT, data: contentData };
};


export const successActionAEMContentProductChange = (contentData) => {
  // initiate the live chat at product level
  const currentProduct = getCurrentProduct();
  window.parent.tcom.researchInsights.appConfig.currentProduct = currentProduct;
  if (ENABLE_LIVE_CHAT && contentData.liveChat) {
    // calling the function to setup salesforce content data load process
    if (window.initSFDCChat && LIVE_CHAT_SUPPORTED_PRODUCTS.includes(currentProduct)) {
      if (DEBUG_MODE) {
        console.log('live chat process started for product:', currentProduct);    // eslint-disable-line
      }
      window.liveChatContentData = contentData.liveChat;
      restartLiveChatForProduct();
    }
  }
  return { type: COMPLETE_AUTHOR_CONTENT, data: contentData };
};

export const failureAction = (error) => {
  history.push(`${APP_CONFIG.reactBasePath}/error`);
  return { type: ERROR_AUTHOR_CONTENT, error };
};

export const loadSelectedProduct = data => (dispatch) => {
  dispatch({ type: INITIATE_AUTHOR_CONTENT });
  let aemEndPoint = '';
  sessionStorage.setItem('currentProduct', data.productType);
  const accountChange = sessionStorage.getItem('accountChange') === 'Yes';
  window.parent.tcom.researchInsights.appConfig.currentProduct = data.productType;
  if (data.productType === 'SSM') {
    showHideOldNewHeaderFooter(false);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
  } else if (data.productType === 'MBS') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT;
  } else if (data.productType === 'FFWD') {
    showHideOldNewHeaderFooter(true);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_FFWD;
  } else if (data.productType === 'NGM') {
    showHideOldNewHeaderFooter(true);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_NGM;
  } else if (data.productType === 'AMS') {
    showHideOldNewHeaderFooter(true);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_AMS;
  } else if (data.productType === 'AMC') {
    showHideOldNewHeaderFooter(true);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_AMC;
  } else if (data.productType === 'AMP') {
    showHideOldNewHeaderFooter(true);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_AMP;
  } else if (data.productType === 'SCT') {
    showHideOldNewHeaderFooter(true);
    aemEndPoint = AEM_AUTHOR_ENDPOINT_SCT;
  }

  if (accountChange && data.productType === 'SSM') {
    dispatch(getSSMCustomerData());
  } else if (accountChange && data.productType === 'MBS') {
    dispatch(startNewBusinessCase());
  } else if (accountChange && data.productType === 'FFWD') {
    dispatch(getFFWDCustomerData());
  } else if (accountChange && data.productType === 'NGM') {
    dispatch(getNGMCustomerData());
  } else if (accountChange && data.productType === 'AMS') {
    dispatch(getAMSCustomerData());
  } else if (accountChange && data.productType === 'AMC') {
    dispatch(getAMCCustomerData());
  } else if (accountChange && data.productType === 'AMP') {
    dispatch(getAMPCustomerData());
  } else if (accountChange && data.productType === 'SCT') {
    dispatch(getSCTCustomerData());
  }
  aemApiGet(dispatch, aemEndPoint, successActionAEMContent, failureAction, data);
};

export const LoadNewSelectedProduct = data => (dispatch) => {
  dispatch({ type: INITIATE_AUTHOR_CONTENT });
  let aemEndPoint = '';
  sessionStorage.setItem('currentProduct', data.productType);
  window.parent.tcom.researchInsights.appConfig.currentProduct = data.productType;
  if (data.productType === 'SSM') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
    showHideOldNewHeaderFooter(false);
    dispatch(getSSMCustomerData());
  } else if (data.productType === 'MBS') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT;
    dispatch(startNewBusinessCase());
  } else if (data.productType === 'FFWD') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_FFWD;
    showHideOldNewHeaderFooter(true);
    dispatch(getFFWDCustomerData());
  } else if (data.productType === 'NGM') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_NGM;
    showHideOldNewHeaderFooter(true);
    dispatch(getNGMCustomerData());
  } else if (data.productType === 'AMS') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_AMS;
    showHideOldNewHeaderFooter(true);
    dispatch(getAMSCustomerData());
  } else if (data.productType === 'AMC') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_AMC;
    showHideOldNewHeaderFooter(true);
    dispatch(getAMCCustomerData());
  } else if (data.productType === 'AMP') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_AMP;
    showHideOldNewHeaderFooter(true);
    dispatch(getAMPCustomerData());
  } else if (data.productType === 'SCT') {
    aemEndPoint = AEM_AUTHOR_ENDPOINT_SCT;
    showHideOldNewHeaderFooter(true);
    dispatch(getSCTCustomerData());
  }
  aemApiGet(dispatch, aemEndPoint, successActionAEMContentProductChange, failureAction, data);
};

export const getAEMContent = data => (dispatch) => {
  const locationHash = window.location.hash;
  const isProductSelectionCompleted = window.tcom.researchInsights.appConfig.currentProduct !== undefined;
  const isUCidnProcessCompleted = window.tcom.researchInsights.appConfig.uCidn !== undefined;
  if (!isRedirectedAfterLogin(locationHash)) {
    const aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
    aemApiGet(dispatch, aemEndPoint, successActionAEMContent, failureAction, data);
  } else if (window === window.parent && !isUCidnProcessCompleted) {
    if (ENABLE_NEW_HEADER_FOOTER_DESIGN) {
      const globalHeader = document.getElementsByClassName('globalHeader')[0];
      if (globalHeader) {
        globalHeader.classList.add('d-none');
      }
      const localHeader = document.getElementsByClassName('localHeader')[0];
      if (localHeader) {
        localHeader.classList.add('d-none');
      }
      const localFooter = document.getElementsByClassName('localFooter')[0];
      if (localFooter) {
        localFooter.classList.add('d-none');
      }
      const globalFooter = document.getElementsByClassName('globalFooter')[0];
      if (globalFooter) {
        globalFooter.classList.add('d-none');
      }
    }
    // ucidn section
    apiGetWithoutDispatch(API_END_POINT_UCIDN_LIST)
      .then((responseData) => {
        if (responseData === undefined) {
          showHideOldNewHeaderFooter(false);
          dispatch({ type: PRODUCT_SELECTION_ERROR });
          return;
        }
        const cidnList = responseData && responseData.data.cidnList;
        if (cidnList.length === 1) {
          const cidnValue = cidnList[0].encryptedCidn;
          window.parent.tcom.researchInsights.appConfig.currentAccount = cidnValue;
          const productListEndpoint = `${API_END_POINT_GET_PRODUCT_TYPE}?value=${encodeURIComponent(cidnValue)}`;
          apiGetWithoutDispatch(productListEndpoint)
            .then((responseProductData) => {
              let aemEndPoint = '';
              if (responseProductData === undefined) {
                showHideOldNewHeaderFooter(false);
                dispatch({ type: PRODUCT_SELECTION_ERROR });
                return;
              }
              const productCount = responseProductData && responseProductData.data.productType.length;
              window.parent.tcom.researchInsights.appConfig.productType = responseProductData.data.productType.join();
              if (productCount === 1) {
                sessionStorage.setItem('currentProduct', responseProductData.data.productType[0]);
                window.tcom.researchInsights.appConfig.currentProduct = responseProductData.data.productType[0];
                if (responseProductData.data.productType[0] === 'SSM') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
                } else if (responseProductData.data.productType[0] === 'MBS') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT;
                } else if (responseProductData.data.productType[0] === 'FFWD') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_FFWD;
                } else if (responseProductData.data.productType[0] === 'NGM') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_NGM;
                } else if (responseProductData.data.productType[0] === 'AMS') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_AMS;
                } else if (responseProductData.data.productType[0] === 'AMC') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_AMC;
                } else if (responseProductData.data.productType[0] === 'AMP') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_AMP;
                } else if (responseProductData.data.productType[0] === 'SCT') {
                  aemEndPoint = AEM_AUTHOR_ENDPOINT_SCT;
                }
                aemApiGet(dispatch, aemEndPoint, successActionAEMContent, failureAction, data);
              } else if (productCount > 1) {
                sessionStorage.setItem('currentProduct', 'NO_SELECTION');
                sessionStorage.setItem('productType', responseProductData.data.productType.join());
                dispatch({ type: SHOW_PRODUCT_SELECTION_OPTIONS, data: responseProductData.data.productType });
              }
            });
        } else {
          dispatch({ type: SHOW_UCIDN_LIST_OPTIONS, data: responseData.data.cidnList });
        }
      });
  } else if (window === window.parent && !isProductSelectionCompleted) {
    if (ENABLE_NEW_HEADER_FOOTER_DESIGN) {
      const globalHeader = document.getElementsByClassName('globalHeader')[0];
      if (globalHeader) {
        globalHeader.classList.add('d-none');
      }
      apiGetWithoutDispatch(API_END_POINT_GET_PRODUCT_TYPE)
        .then((responseData) => {
          let aemEndPoint = '';
          if (responseData === undefined) {
            showHideOldNewHeaderFooter(false);
            dispatch({ type: PRODUCT_SELECTION_ERROR });
          }
          const productCount = responseData && responseData.data.productType.length;
          if (productCount === 1) {
            sessionStorage.setItem('currentProduct', responseData.data.productType[0]);
            window.tcom.researchInsights.appConfig.currentProduct = responseData.data.productType[0];
            if (responseData.data.productType[0] === 'SSM') {
              showHideOldNewHeaderFooter(false);
              aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
            } else if (responseData.data.productType[0] === 'MBS') {
              aemEndPoint = AEM_AUTHOR_ENDPOINT;
            } else if (responseData.data.productType[0] === 'FFWD') {
              showHideOldNewHeaderFooter(true);
              aemEndPoint = AEM_AUTHOR_ENDPOINT_FFWD;
            } else if (responseData.data.productType[0] === 'NGM') {
              showHideOldNewHeaderFooter(true);
              aemEndPoint = AEM_AUTHOR_ENDPOINT_NGM;
            } else if (responseData.data.productType[0] === 'AMS') {
              aemEndPoint = AEM_AUTHOR_ENDPOINT_AMS;
            }
            aemApiGet(dispatch, aemEndPoint, successActionAEMContent, failureAction, data);
          } else if (productCount > 1) {
            sessionStorage.setItem('currentProduct', 'NO_SELECTION');
            sessionStorage.setItem('productType', responseData.data.productType.join());
            window.tcom.researchInsights.appConfig.productType = responseData.data.productType.join();
            dispatch({ type: SHOW_PRODUCT_SELECTION_OPTIONS, data: responseData.data.productType });
          }
        });
    } else {
      console.log('in else part after renewal'); // eslint-disable-line
      const currentProduct = window.parent.tcom.researchInsights.appConfig.currentProduct;
      if (currentProduct !== undefined) {
        sessionStorage.setItem('currentProduct', currentProduct);
      }
      const localHeader = document.getElementsByClassName('localHeader')[0];
      if (localHeader) {
        localHeader.classList.add('d-none');
      }
      const localFooter = document.getElementsByClassName('localFooter')[0];
      if (localFooter) {
        localFooter.classList.add('d-none');
      }
      const globalFooter = document.getElementsByClassName('globalFooter')[0];
      if (globalFooter) {
        globalFooter.classList.add('d-none');
      }
    }

    apiGetWithoutDispatch(API_END_POINT_GET_PRODUCT_TYPE)
      .then((responseData) => {
        if (responseData === undefined) {
          showHideOldNewHeaderFooter(false);
          dispatch({ type: PRODUCT_SELECTION_ERROR });
          return;
        }
        let aemEndPoint = '';
        const productCount = responseData && responseData.data.productType.length;
        if (productCount === 1) {
          sessionStorage.setItem('currentProduct', responseData.data.productType[0]);
          window.tcom.researchInsights.appConfig.currentProduct = responseData.data.productType[0];
          if (responseData.data.productType[0] === 'SSM') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
          } else if (responseData.data.productType[0] === 'MBS') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT;
          } else if (responseData.data.productType[0] === 'FFWD') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_FFWD;
          } else if (responseData.data.productType[0] === 'NGM') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_NGM;
          } else if (responseData.data.productType[0] === 'AMS') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_AMS;
          } else if (responseData.data.productType[0] === 'AMC') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_AMC;
          } else if (responseData.data.productType[0] === 'AMP') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_AMP;
          } else if (responseData.data.productType[0] === 'SCT') {
            aemEndPoint = AEM_AUTHOR_ENDPOINT_SCT;
          }
          aemApiGet(dispatch, aemEndPoint, successActionAEMContent, failureAction, data);
        } else if (productCount > 1) {
          sessionStorage.setItem('currentProduct', 'NO_SELECTION');
          sessionStorage.setItem('productType', responseData.data.productType.join());
          window.parent.tcom.researchInsights.appConfig.productType = responseData.data.productType.join();
          dispatch({ type: SHOW_PRODUCT_SELECTION_OPTIONS, data: responseData.data.productType });
        }
      });
  } else {
    console.log('in else part after renewal'); // eslint-disable-line
    const currentProduct = window.parent.tcom.researchInsights.appConfig.currentProduct;
    if (currentProduct !== undefined) {
      sessionStorage.setItem('currentProduct', currentProduct);
    }
    const productType = window.parent.tcom.researchInsights.appConfig.productType;
    if (productType !== undefined) {
      sessionStorage.setItem('productType', productType);
    }
    const renewInterval = window.parent.tcom.researchInsights.appConfig.renewInterval;
    if (renewInterval !== undefined) {
      sessionStorage.setItem('renewInterval', renewInterval);
    }
  }
};

export const getAEMContentForPurlApps = data => (dispatch) => {
  const eventRouteDetails = getEventRouteAndUserHashDetails();
  let endpoint;
  let newHeaderShow = false;
  if (eventRouteDetails.isEventRouteAndUserHashPresent) {
    endpoint = AEM_VANTAGE_AUTHOR_ENDPOINT;
  } else if (eventRouteDetails.isHostedRoutePresent) {
    endpoint = AEM_HOSTED_MIGRATION_AUTHOR_ENDPOINT;
  } else if (eventRouteDetails.isBusinessPopMailRoutePresent) {
    endpoint = AEM_BUSINESS_POP_MAIL_AUTHOR_ENDPOINT;
  } else if (eventRouteDetails.isAdaptiveMobilityExternalPresent) {
    endpoint = AEM_ADAPTIVE_MOBILITY_EXTERNAL_AUTHOR_ENDPOINT;
    newHeaderShow = true;
  } else if (eventRouteDetails.isPartnerView) {
    endpoint = AEM_AUTHOR_ENDPOINT_AMP;
    newHeaderShow = true;
  }
  dispatch({ type: INITIATE_AUTHOR_CONTENT });
  showHideOldNewHeaderFooter(newHeaderShow);
  aemApiGet(dispatch, endpoint, successActionAEMContent, failureAction, data);
};


export const getProductSelectionForUCidnSelection = key => (dispatch) => {
  const endpoint = `${API_END_POINT_GET_PRODUCT_TYPE}?value=${encodeURIComponent(key)}`;
  window.parent.tcom.researchInsights.appConfig.currentAccount = key;
  apiGetWithoutDispatch(endpoint)
    .then((responseData) => {
      if (responseData === undefined) {
        showHideOldNewHeaderFooter(false);
        dispatch({ type: PRODUCT_SELECTION_ERROR });
        return;
      }
      let aemEndPoint = '';
      const productCount = responseData.data.productType.length;
      window.parent.tcom.researchInsights.appConfig.productType = responseData.data.productType.join();
      if (productCount === 1) {
        sessionStorage.setItem('currentProduct', responseData.data.productType[0]);
        if (responseData.data.productType[0] === 'SSM') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_SSM;
        } else if (responseData.data.productType[0] === 'MBS') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT;
        } else if (responseData.data.productType[0] === 'FFWD') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_FFWD;
        } else if (responseData.data.productType[0] === 'NGM') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_NGM;
        } else if (responseData.data.productType[0] === 'AMS') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_AMS;
        } else if (responseData.data.productType[0] === 'AMC') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_AMC;
        } else if (responseData.data.productType[0] === 'AMP') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_AMP;
        } else if (responseData.data.productType[0] === 'SCT') {
          aemEndPoint = AEM_AUTHOR_ENDPOINT_SCT;
        }
        aemApiGet(dispatch, aemEndPoint, successActionAEMContent, failureAction, key);
      } else if (productCount > 1) {
        sessionStorage.setItem('currentProduct', 'NO_SELECTION');
        sessionStorage.setItem('productType', responseData.data.productType.join());
        dispatch({ type: SHOW_PRODUCT_SELECTION_OPTIONS, data: responseData.data.productType });
      }
    });
};

export const getProductSelectionForAccount = (accountKey) => {
  const endpoint = `${API_END_POINT_GET_PRODUCT_TYPE}?value=${encodeURIComponent(accountKey)}`;
  window.parent.tcom.researchInsights.appConfig.currentAccount = accountKey;
  return apiGetWithoutDispatch(endpoint);
};
